import { PAGE_TITLES } from 'Constants/page.constants'
import styles from './ExamDetail.module.less'
import HeaderComp from 'Components/common/Header/Header'
import { VideoCard } from 'Components/common/Cards/VideoCard/VideoCard'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { ExamInformation } from './ExamInformation/ExamInformation'
import { useExamDetail } from 'Hooks/exams/use-exam-detail'
import { Loader } from 'Components/common/Loader/Loader'
import HtmlRenderer from 'Utils/htmlRenederer.utils'
import { useExamProgress } from 'Hooks/exams/use-exam-progress'
import { useTitle } from 'Hooks/use-title'
import { HomeTabKeys } from 'Constants/constants'
import { notification } from 'antd/lib'
import { useEffect } from 'react'

export const ExamDetailPage: React.FC = () => {
    const navigate = useNavigate()
    useTitle(PAGE_TITLES.EXAM_DETAIL)

    const { data, isLoading } = useExamDetail()
    const { examProgressTag, isExamInProgress, getTimeLeftInSecs } = useExamProgress({
        timeLimitInSeconds: data?.exam.time_limit_in_seconds,
        attempt: data?.exam.attempt,
    })

    // Show error notification if exam is archived
    useEffect(() => {
        if (data?.exam.is_archived) {
            notification.error({
                message: 'Exam Archived',
                description: 'This exam has been archived and is no longer available for attempts.',
                placement: 'bottomLeft',
            })
        }
    }, [data?.exam.is_archived])

    const goBackToExams = () => {
        navigate('/', {
            state: {
                type: HomeTabKeys.Exams,
            },
        })
    }

    if (!data || isLoading) {
        return <Loader title="Loading exam details..." />
    }

    return (
        <div className={styles['exam-detail-page']} data-testid="exam-detail-wrapper">
            <HeaderComp />
            <div className={styles['body']}>
                <div className={styles['exam-instruction-text']}>
                    <button onClick={goBackToExams} className={styles['back-to-exams']}>
                        <ArrowLeftOutlined /> Back to Exams
                    </button>
                    <div className={styles['instruction-title-container']}>
                        <h1 className={styles['instruction-title']}>{data?.exam.name}</h1>
                        {examProgressTag}
                    </div>
                    <h2 className={styles['instruction-text']}>Instructions</h2>
                    <h3 className={styles['instruction-details']}>
                        <HtmlRenderer
                            htmlContent={data?.exam.instruction.content}
                            className={styles['exams-html-wrapper']}
                        />
                    </h3>
                </div>
                <div className={styles['exam-instruction-video']}>
                    <div className={styles['tutorial-container']}>
                        <VideoCard
                            title="Exam intro video"
                            description="The above video provides details about the exam interface tool"
                            extra={
                                <ExamInformation
                                    questions={data?.exam.num_of_questions}
                                    duration={data?.exam.time_limit_in_seconds}
                                    attempts={data?.exam.attempts_remaining}
                                    attempt={data?.exam.attempt}
                                    isInProgress={isExamInProgress}
                                    isArchived={data?.exam.is_archived}
                                    timeLeftInSecs={getTimeLeftInSecs()}
                                />
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
